export default {"src":"/sitetest/_next/static/media/arr_icon.5e94889d.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};